import { combineReducers } from "redux";
import route from "./route/reducer";
import shopping from "./shopping/reducer";

const rootReducer = combineReducers({
  shopping,
  route,
});

export default rootReducer;
